import { CopyToClipboard } from "react-copy-to-clipboard";

import { IconButton, Tooltip } from "@mui/material";
import { CopyIcon } from "@phosphor-icons/react/dist/csr/Copy";
import { toast } from "react-toastify";
import withSwallowClick from "../SwallowClick";
import "./styles.css";

type IconCopyProps = {
  tooltip?: string;
  clipboard?: string | null;
  size?: string | number;
};

const IconCopy = ({ tooltip, clipboard = null, size }: IconCopyProps) => {
  const tooltip_full_text = `Copy to clipboard -> ${tooltip}`;

  const clipboardText = clipboard || tooltip || "";

  return (
    <div onClick={(e) => e.preventDefault()} aria-hidden="true">
      <CopyToClipboard
        text={clipboardText}
        tooltip-full-text={tooltip_full_text}
        onCopy={() => toast.success("Copied to clipboard!")}
      >
        <Tooltip id="tooltip" title={tooltip_full_text} placement="right" arrow open={!tooltip ? false : undefined}>
          <IconButton data-cy="tooltip-container-copy-to-clipboard">
            <CopyIcon size={size} />
          </IconButton>
        </Tooltip>
      </CopyToClipboard>
    </div>
  );
};

export default withSwallowClick(IconCopy);
